// Импортируется в common.js

$(function() {
    $('#form-reset').click(function() {
        $('#search-form input').each(function() {
            if (
                $(this).attr('type') == 'button' ||
                $(this).attr('type') == 'submit' ||
                $(this).attr('type') == 'radio'
            ) {
            } else {
                $(this).val('');
                $(this).attr('checked', false);
            }
        });

        $('#search-form select').each(function() {
            $(this).prop('selectedIndex', 0);
        });

        return false;
    });

    $('.u-datepicker input').datepicker({
        format: 'dd-mm-yyyy',
        minViewMode: 0,
        autoclose: true,
        language: 'ru',
    });

    $('#search-form')
        .find('input')
        .keypress(function(event) {
            if (event.which == 13) {
                event.preventDefault();
                $('#search-form').submit();
            }
        });
});

$(document).on('mouseenter', '.select2-selection__rendered', function () { $(this).removeAttr('title');  });

$(document).ready(function($) {
    /**
     * Страница материалов
     */
    checkSelectedValue();

    $('select#id_is_edited').on('change', function() {
        checkSelectedValue();
    });

    function checkSelectedValue() {
        if ($('select#id_is_edited option:selected').val() !== 'yes') {
            $('#id_edited_by').attr('disabled', 'disabled');
            $('#id_edited_by option:eq(0)').prop('selected', true);
        } else {
            $('#id_edited_by').removeAttr('disabled');
        }
    }

    /**
     * Открыть/закрыть секции в панели поиска персон
     **/

    $('.hide-body-btn').on('click', function() {
        $(this).toggleClass('glyphicon-minus-sign');
        $(this)
            .closest('.panel-heading')
            .siblings('.panel-body')
            .slideToggle('fast');
    });

    /**
     * Страница персон
     */

    function disableSelectBox(controllerId) {
        if ($('select#' + controllerId + ' option:selected').val() !== 'yes') {
            $('#' + controllerId + '_by').attr('disabled', 'disabled');
            $('#' + controllerId + '_by option:eq(0)').prop('seleced', true);
        } else {
            $('#' + controllerId + '_by').removeAttr('disabled');
        }
    }

    disableSelectBox('id_common_edited');
    disableSelectBox('id_literary_edited');

    $('select#id_common_edited').on('change', function() {
        disableSelectBox('id_common_edited');
    });

    $('select#id_literary_edited').on('change', function() {
        disableSelectBox('id_literary_edited');
    });

    function fillProceedCity() {
        let searchParams = new URLSearchParams(window.location.search);
        if (window.location.href.includes('/persons/') && searchParams.has('proceed_city_id_hidden')) {
            const id = searchParams.get('proceed_city_id_hidden');
            $.ajax({
                url: '/cabinet/ajax/get_proceed_city_name/' + id + '/',
                success: function (data) {
                   console.log(data);
                    $('#proceed_city_id').val(data.name);
                },
                async: true,
            }).fail(function () {
                console.log(error);
            });
        }
    }

    fillProceedCity()

    /**
     * Комбобокс просмотрено научным редактором
     */

    checkScientificSelect();

    $('select#id_scientific_edited').on('change', function() {
        checkScientificSelect();
    });

    function checkScientificSelect() {
        var selectedValue = $('select#id_scientific_edited option:selected').val();

        if (selectedValue === '' || selectedValue === 'no_never' || selectedValue === 'no_before') {
            $('#id_scientific_edited_by_set_1').attr('disabled', 'disabled');
            $('#id_scientific_edited_by_set_1 option:eq(0)').prop('selected', true);
            $('#id_scientific_edited_by_set_2')
                .closest('.input-group')
                .hide();
        } else if (selectedValue === 'yes') {
            $('#id_scientific_edited_by_set_1').removeAttr('disabled');
            $('#id_scientific_edited_by_set_1')
                .closest('.input-group')
                .show();
            $('#id_scientific_edited_by_set_2')
                .closest('.input-group')
                .hide();
        } else {
            $('#id_scientific_edited_by_set_2').removeAttr('disabled');
            $('#id_scientific_edited_by_set_1')
                .closest('.input-group')
                .hide();
            $('#id_scientific_edited_by_set_2')
                .closest('.input-group')
                .show();
        }
    }

    function openPanelOnInit() {
        $('.panel-body-js select').each(function() {
            if (!!$(this).val()) {
                $('.hide-body-btn').trigger('click');
                return;
            }
        });
    }

    openPanelOnInit();
});
